import React, { Component } from 'react';
import { FormGroup, Row, Col, Label, Input, FormText } from 'reactstrap';

export default class LicensesCertificates extends Component {
    constructor(props) {
        super(props)

        this.state = {

        };
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm='12'>
                        <FormGroup>
                            <Label>License Name</Label>
                            <Input name='name' required maxLength="50" value={this.props.item.name || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col sm='6'>
                        <FormGroup>
                            <Label>Original License Date</Label>
                            <Input type="date" required name='licenseDate' value={this.props.item.licenseDate || ''} onChange={this.props.onChange} max="9999-12-31" />
                            <FormText color="muted">Format: mm/dd/yyyy</FormText>
                        </FormGroup>
                    </Col>
                    <Col sm='6'>
                        <FormGroup>
                            <Label>Licensing Agency</Label>
                            <Input required name='agency' maxLength='50' value={this.props.item.agency || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}